// extracted by mini-css-extract-plugin
export default {"form-container":"location-form_form-container__f8kS6","text-holder":"location-form_text-holder__wCHOP","delete-icon":"location-form_delete-icon__LGwoA"};